import { getUserLink } from 'utils'
import { getWorkspaceById } from '~workspace/api/getWorkspaceById'
import { searchMapsByWorkspaceId } from '~workspace/api/searchMapsByWorkspaceId'
import { MAPS_LIMIT } from '~workspace/constants/maps'

const getServerSideProps = async (context) => {
  const { params, query } = context
  const { workspaceId } = params
  const { page = 1, tags, query: requestQuery } = query

  let maps, workspace
  try {
    const offset =
      page && !isNaN(Number(page)) ? (parseInt(page) - 1) * MAPS_LIMIT : 0

    maps = await searchMapsByWorkspaceId({
      workspaceId,
      limit: MAPS_LIMIT,
      offset,
      query: requestQuery,
      tagIds: (tags && tags.split(',')) || []
    })

    workspace = await getWorkspaceById(workspaceId)
  } catch (error) {
    console.warn(error)
  }

  if (workspace?.defaultUser) {
    const { id, firstName, lastName } = workspace.defaultUser
    return {
      redirect: {
        destination: getUserLink({ userId: id, firstName, lastName })
      }
    }
  }

  return {
    props: {
      maps,
      workspace
    }
  }
}

export { getServerSideProps }
